module.exports = __webpack_public_path__ + "img/logo.5c2f47b9.png";